import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import { useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface CreditsafeReportFormatSectionProps {
	availableReportFormats: string[];
	reportFormat?: string;
	setReportFormat: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export default function CreditsafeReportFormatSection(props: CreditsafeReportFormatSectionProps) {
	const { t } = useSettings();

	return (
		<DetailsSectionWrapper
			classes={{ header: 'pb-0' }}
			title={t('DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_TITLE')}
		>
			<FormControl className="pt-8">
				<RadioGroup value={props.reportFormat} onChange={(_event, value) => props.setReportFormat(value)}>
					{props.availableReportFormats.map(format => (
						<FormControlLabel
							key={format}
							value={format}
							control={<Radio />}
							label={t(`DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_${format}`)}
						/>
					))}
				</RadioGroup>
			</FormControl>
		</DetailsSectionWrapper>
	);
}
